import { ServiceType } from "@agroyaar/sdk";
import Footer from "./Footer";
import Header from "./Header";

interface ReportTemplateProps {
  children: React.ReactNode;
  serviceType: ServiceType;
  pageNumber: number;
  reportCode?: string;
}

const ReportTemplate = ({
  children,
  pageNumber,
  reportCode,
  serviceType,
}: ReportTemplateProps) => {
  return (
    <section
      id={`ReportTemplate-${pageNumber}`}
      className="flex flex-col justify-between items-center w-full h-[1048px] relative !font-[B-Nazanin]"
    >
      <Header serviceType={serviceType} />

      <div className="flex flex-col justify-start items-start flex-grow w-full px-8 !font-[B-Nazanin]">
        {children}
      </div>

      <Footer
        pageNumber={pageNumber}
        reportCode={reportCode}
        serviceType={serviceType}
      />
    </section>
  );
};

export default ReportTemplate;
